export const environment = {
  production: true,
  msg: "lol"

};



// WEBPACK FOOTER //
// ./src/environments/environment.ts